import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { get } from 'lodash';

import SenderDetailsTabDomains from './sender-details-tab-domains';

import { domainsDataBySender } from './selectors/sender-details-selectors';
import { fetchDomainsByRecognizedSender } from '../common/actions/recognized-senders-action-creators';
import { openVerificationByDomainModal } from '../common/actions/modal-action-creators';

export class SenderDetailsDomainTabContainer extends Component{
    componentDidMount(){
        this.fetchData();
    }

    componentDidUpdate( prevProps ){
        const { senderId } = this.props;

        if( get( prevProps, 'senderId' ) !== senderId ){
            this.fetchData();
        }
    }

    fetchData(){
        const { senderId, fetchDomainsByRecognizedSender } = this.props;

        fetchDomainsByRecognizedSender( senderId );
    }

    render(){
        const { senderName, domainsData, openVerificationByDomainModal } = this.props;
        return (
            <SenderDetailsTabDomains
                domainsData={domainsData}
                onEdit={openVerificationByDomainModal}
                senderName={senderName}
            />
        );
    }
}

SenderDetailsDomainTabContainer.propTypes = {
    domainsData: PropTypes.array.isRequired,
    fetchDomainsByRecognizedSender: PropTypes.func.isRequired,
    openVerificationByDomainModal: PropTypes.func.isRequired,
    senderId: PropTypes.string.isRequired,
    senderName: PropTypes.string.isRequired,
};

/* istanbul ignore next */
function mapStateToProps( state ){
    return {
        domainsData: domainsDataBySender( state )
    };
};

const mapDispatchToProps = {
    fetchDomainsByRecognizedSender,
    openVerificationByDomainModal
};

export default connect( mapStateToProps, mapDispatchToProps )( SenderDetailsDomainTabContainer );
